import { render } from "./TheLeftSidebar.vue?vue&type=template&id=2720c313"
import script from "./TheLeftSidebar.vue?vue&type=script&lang=js"
export * from "./TheLeftSidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__